import React, {useEffect, useRef, useState} from 'react';
import {useCurrentLocale, useLocalizedLabels, GreekLanguage} from "widget-shared-components-library";
import ListingLabels from "./Listing.Labels";
import mapping from "../../config/mapping";
import TagManager from 'react-gtm-module'
import useParams from "../../hooks/useParams";
import useAxiosInstance from "../../hooks/useAxiosInstance";


// const tagManagerArgs = {
//     gtmId: 'GTM-MN5D67'
// }
// TagManager.initialize(tagManagerArgs)

const useListing = () => {
    const initialedObject = {
        items: [],
        count: 0
    };

    const axiosInstance = useAxiosInstance();
    const lang = useCurrentLocale();
    const labels = useLocalizedLabels(ListingLabels);
    const {categoryIdList,categoryNameList} = useParams();

    //searchhub params
    const [devices, setDevices] = useState(initialedObject);
    const [rateplans, setRateplans] = useState(initialedObject);
    const [articles, setArticles] = useState(initialedObject);
    const [support, setSupport] = useState(initialedObject);
    const [filterItems, setFilterItems] = useState([]);
    const [filtersForRequest, setFiltersForRequest] = useState([]);
    const [expandedSubCategories, setExpandedSubCategories] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedTabOption, setSelectedTabOption] = useState(null);

    //promotional products
    const [promotionalIdsList, setPromotionalIdsList] = useState([]);
    const [promoProductsReady, setPromoProductsReady] = useState(false);
    const [promotionDevices, setPromotionDevices] = useState([]);

    //price
    // const [minPriceRange, setMinPriceRange] = useState(0);
    // const [maxPriceRange, setMaxPriceRange] = useState(50);
    const [minPriceRange, setMinPriceRange] = useState(-1);
    const [maxPriceRange, setMaxPriceRange] = useState(-1);
    const [minPrice, setMinPrice] = useState(null);
    const [maxPrice, setMaxPrice] = useState(null);
    // const minPriceRange = useRef(null);
    // const maxPriceRange = useRef(null);
    // const prevPriceRangeRef = useRef([null, null]);
    const [isUserInteractedPrice, setIsUserInteractedPrice] = useState(false);

    // Pagination state and constants
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState([4]);
    const [displayPages, setDisplayPages] = useState([]);

    // Product sorting dropdown
    const [productSorting, setProductSorting] = useState([]);

    // pagination
    const [selectedProductsPerPage, setSelectedProductsPerPage] = useState({label: labels['perPage12'], value: 12});
    const [selectedProductsSorting, setSelectedProductsSorting] = useState(new URLSearchParams(window.location.search).get('sort')?.trim() ?? '');

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

    const [parametersReady, setParametersReady] = useState(false);


    // Product per page dropdown
    const productsPerPage = mapping.getProductsPerPage(labels);

    const callSearchHubForSortingOptions = (collectionSet) => {
        axiosInstance.get(process.env.REACT_APP_API_SORTING_OPTIONS, {
            params: {
                language: lang === GreekLanguage ? 'gr' : 'en',
                collectionSet: collectionSet === 'rateplans' ? 'services' : collectionSet
            }
        })
            .then((response) => {
                if (Array.isArray(response?.data?.sortingOptions) && response?.data?.sortingOptions?.length > 0) {
                    /** @type Array<{id?: string; label?: string}> */
                    const productSorting = response.data.sortingOptions
                        .filter(it => typeof it.id == 'string' && typeof it.label == 'string');
                    setProductSorting(productSorting);
                    if (selectedProductsSorting === '') {
                        const _selectedProductsSorting = productSorting.some(it => it.id === 'score')
                            ? 'score'
                            : productSorting.at(0)?.id ?? ''
                        setSelectedProductsSorting(_selectedProductsSorting);
                        if (selectedProductsSorting !== _selectedProductsSorting && _selectedProductsSorting !== 'score') {
                            updateURL("sort", _selectedProductsSorting);
                        }
                    }
                } else {
                    setProductSorting([]);
                }
            })
            .catch((error) => {
                console.error(error);
                setProductSorting([]);
            });
    }

    const handleSelectionClick = (option) => () => {
        setCurrentPage(1);
        updateURL("selectedTabOption", option);
        setSelectedTabOption(option);
    };

    const updateURL = (name, value) => {
        const currentURL = new URL(window.location.href);
        if (name == 'availability') {
            value = "inStock,lowStock";
        }
        currentURL.searchParams.set(name, value);
        window.history.pushState({}, '', currentURL);
        window.location.href = currentURL.toString();
    }

    // Pagination handlers
    const handlePageChange = (pageNum) => {
        setCurrentPage(pageNum);
        updateURL("page", pageNum);
    };
    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            updateURL("page", currentPage - 1);
        }
    };
    const handleNext = () => {
        if (currentPage < totalPages[totalPages.length - 1]) {
            setCurrentPage((prev) => prev + 1);
            updateURL("page", currentPage + 1);
        }

    };

    const onPageChange = (page) => {
        setDisplayPages(prevArray => prevArray.map(num => num + 1))
        setCurrentPage(page);
    }
    const handleLearnMore = (productUrl) => {
        window.location.href = window.location.origin+productUrl;
    };

    const handleResponse = (data) => {
        setMinPriceRange((data?.minPrice != null && data?.minPrice < 0) ? 0.0 : data?.minPrice);
        setMaxPriceRange(data?.maxPrice);
        const updatedDevices = {
            ...data?.devices,
            items: data?.devices?.items?.map(item => ({
                ...item,
                initialPrice: item.initialPrice === -1 ? 0 : item.initialPrice,
                finalPrice: item.finalPrice === -1 ? 0 : item.finalPrice,
                characteristics: item.characteristics?.map(char => ({
                    ...char,
                    initialPrice: char.initialPrice === -1 ? 0 : char.initialPrice,
                    finalPrice: char.finalPrice === -1 ? 0 : char.finalPrice,
                })),
            })),
        };
        setDevices(updatedDevices);
        if (data?.rateplans?.items) {
            const updated = {
                ...data.rateplans,
                items: data.rateplans.items.map(item => ({
                    ...item,
                    initialPrice: item.initialPrice === -1 ? 0 : item.initialPrice,
                    finalPrice: item.finalPrice === -1 ? 0 : item.finalPrice,
                })),
            };
            setRateplans(updated);
        }
        setArticles(data?.articles);
        setSupport(data?.support);
        setFilterItems(data?.filters);
        setSelectedTabOption(data?.devices?.count > 0 ? 'products' : 'rateplans');
        const expandedCategories = data.filters.reduce((acc, item) => {
            if ((item?.title === 'Κατηγορία' || item?.title === 'Category') && item?.items && item?.items.length > 0) {
                const processSubItems = (subItems) => {
                    subItems.forEach(subItem => {
                        acc[subItem?.title] = true;
                        if (subItem?.items && subItem.items.length > 0) {
                            processSubItems(subItem?.items);
                        }
                    });
                };
                processSubItems(item?.items);
            }
            return acc;
        }, {});
        setExpandedSubCategories(expandedCategories);
        setTotalPages(Array.from({length: data?.pages}, (_, i) => i + 1));
    }

    // const localHost = 'http://localhost:8088';
    // const origin = process.env.REACT_APP_POSTPAID_ORIGIN_URL;
    // const isLocalEnv = process.env.NODE_ENV === 'development';
    // const baseUrl = isLocalEnv ? localHost : origin;

    const prepareRequest = (size, order, page, collection, q, promotionalIdsList=[], filters) => {
        setParametersReady(false);
        if (filters) {
            const updatedFilters = [
                ...filters.map(([property, value]) => ({
                    property: property,
                    value: value
                })),
                { property: "categoryPath", value: categoryNameList[categoryNameList.length - 1] }
            ];
            setFiltersForRequest(updatedFilters);
        } else {
            setFiltersForRequest([{ property: "categoryPath", value: categoryNameList[categoryNameList.length - 1] }]);
        }

        if (q || promotionalIdsList?.length > 0) {
            if (promotionalIdsList !=null) {
                setSearchQuery(promotionalIdsList);
            }else {
                setSearchQuery(q);
            }
        }

        if (collection) {
            setSelectedTabOption(collection);
        }

        if (size) {
            prepareParameters(size, productsPerPage, setSelectedProductsPerPage);

        }
        if (order) {
            prepareSortingParameters(order);
        }

        if (page) {
            setCurrentPage(Number(page));
        }
        if (promotionalIdsList?.length > 0) {
            search(filters, true);
        }
        setPromoProductsReady(true);
        setParametersReady(true);

    }

    const prepareParameters = (param, options, setVariable) => {
        const convertToNum = Number(param);
        const object = options.find((item) => item.value === convertToNum);

        if (object) {
            setVariable(object);
        } else {
            setVariable(null);
        }
    }

    const prepareSortingParameters = (sortingChoice) => {
        setSelectedProductsSorting(sortingChoice)
    }

    const search = (filters, isForPromotionalProducts = false) => {
        if (filters != null && filters?.length > 0) {
            axiosInstance.post(process.env.REACT_APP_API_SEARCH_LISTING,
                {
                    q: searchQuery,
                    collectionSet: selectedTabOption ?? 'products',
                    filters: filters,
                    size: selectedProductsPerPage?.value,
                    order: selectedProductsSorting,
                    page: currentPage,
                    language: lang,
                    categoryId: categoryIdList[categoryIdList.length - 1]
                })
                .then((response) => {
                    if (isForPromotionalProducts === true) {
                        setPromotionDevices(response?.data?.devices)
                        setPromoProductsReady(true);
                    }else {
                        handleResponse(response?.data);
                    }

                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const callSearchHubForPromotionalProducts = () => {
        axiosInstance.get(process.env.REACT_APP_API_SEARCH_PROMO)
            .then((response) => {
                setPromotionalIdsList(response?.data?.promotionalProductsIdList);
            })
            .catch((error) => {
                console.error(error);
                setPromotionalIdsList([]);
            });
    }

    const callSearchHub = (promotionalIdsList) => {
        const currentURL = new URLSearchParams(window.location.search);
        if (!currentURL.has('gte')) {
            currentURL.set('gte', '0');
        }

        if (currentURL.has('availability')) {
            currentURL.set('availability', "inStock,lowStock");
        }

        const allParams = {};
        for (const [key, value] of currentURL.entries()) {
            allParams[key] = value;
        }

        const unknownVariables = Object.entries(allParams).filter(([key]) =>
            !['size', 'sort', 'page', 'selectedTabOption', 'q', 'id', 'value'].includes(key)
        );
        setMinPrice(currentURL.get('gte') ?? 0);
        setMaxPrice(currentURL.get('lte') ?? -1);

        prepareRequest(
            currentURL.get('size'),
            currentURL.get('sort'),
            currentURL.get('page'),
            currentURL.get('selectedTabOption'),
            currentURL.get('q'),
            promotionalIdsList,
            unknownVariables
        )
    }

    const onPriceChange = ([newMin, newMax]) => {
        setMinPrice(newMin);
        setMaxPrice(newMax);
    };

    function AfterPriceChange(newMinMax, newMax) {
        const currentURL = new URLSearchParams(window.location.search);
        const currentMin = currentURL.get("gte");
        const currentMax = currentURL.get("lte");

        // if (String(currentMin) === String(newMin) && String(currentMax) === String(newMax)) {
        //     return;
        // }

        if (Array.isArray(newMinMax) && newMinMax.length === 2) {
            currentURL.set("gte", newMinMax[0]);
            currentURL.set("lte", newMinMax[1]);
        }
        // Redirect to the new URL
        window.location.href = `${window.location.pathname}?${currentURL.toString()}`;
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1200);
            setScreenWidth(window.innerWidth)
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (typeof selectedTabOption === 'string' && selectedTabOption.trim().length > 0) {
            callSearchHubForSortingOptions(selectedTabOption.trim())
        }
    }, [selectedTabOption])

    useEffect(() => {
        if (promotionalIdsList?.length > 0) {
            callSearchHub(promotionalIdsList);
        } else {
            callSearchHub([]);
        }

    }, [promotionalIdsList])

    return {
        handlePageChange,
        handlePrevious,
        handleNext,
        selectedTabOption: selectedTabOption ?? 'products',
        totalPages,
        handleSelectionClick,
        onPageChange,
        currentPage,
        displayPages,
        isMobile,
        screenWidth,
        searchQuery,
        devices,
        articles,
        support,
        rateplans,
        filterItems,
        setDisplayPages,
        search,
        updateURL,
        selectedProductsPerPage,
        selectedProductsSorting,
        setSelectedProductsPerPage,
        setSelectedProductsSorting,
        setCurrentPage,
        handleLearnMore,
        labels,
        parametersReady,
        filtersForRequest,
        expandedSubCategories,
        setExpandedSubCategories,
        promotionDevices,
        promoProductsReady,
        callSearchHubForPromotionalProducts,
        onPriceChange,
        minPriceRange,
        maxPriceRange,
        AfterPriceChange,
        minPrice,
        maxPrice,
        categoryNameList,
        lang,
        productSorting
    };
}
export default useListing;
